// ============================================================================
// ARABIC TRANSLATIONS - CHAPTER 4: الصلب والقيامة
// ============================================================================
// المستويات 40-52 (13 مستوى، 39 سؤال)

export const chapter4Translations = {
  name: "الصلب والقيامة",
  description: "لقد قام!",
  
  spiritualWisdom: {
    principle: "من خلال موته وقيامته، يمنحنا يسوع الحياة الأبدية",
    scripture: "أَنَا هُوَ الْقِيَامَةُ وَالْحَيَاةُ. مَنْ آمَنَ بِي وَلَوْ مَاتَ فَسَيَحْيَا (يوحنا 11:25)",
    application: "الصليب والقبر الفارغ هما قلب إيماننا ومصدر رجائنا"
  },
  
  levels: {
    40: {
      name: "القبض",
      challenge: "يَا يَهُوذَا، أَبِقُبْلَةٍ تُسَلِّمُ ابْنَ الإِنْسَانِ؟",
      easy: {
        question: "من خان يسوع؟",
        options: ["بطرس", "يهوذا", "توما", "متى"],
        hint: "أحد التلاميذ الاثني عشر",
        funFact: "💔 باع يهوذا يسوع بثلاثين قطعة من الفضة - ثمن عبد!"
      },
      medium: {
        question: "ما هي العلامة التي استخدمها يهوذا لتحديد هوية يسوع؟",
        options: [
          "أشار إليه بإصبعه",
          "ناداه باسمه",
          "قبّله",
          "عينه للجنود"
        ],
        hint: "إيماءة محبة محرّفة",
        funFact: "😢 القبلة، رمز الحب، تصبح أداة للخيانة!"
      },
      hard: {
        question: "كيف تفاعل يسوع مع الخيانة والقبض عليه؟",
        options: [
          "دافع عن نفسه بعنف",
          "هرب",
          "قبل بكرامة وشفى أذن الخادم",
          "لعن أعداءه"
        ],
        hint: "أظهر الحب حتى لأعدائه",
        funFact: "✨ حتى أثناء إلقاء القبض عليه، شفى يسوع أذن ملخس المقطوعة!"
      }
    },
    
    41: {
      name: "إنكار بطرس",
      challenge: "قَبْلَ أَنْ يَصِيحَ الدِّيكُ تُنْكِرُنِي ثَلاَثَ مَرَّاتٍ...",
      easy: {
        question: "كم مرة أنكر بطرس يسوع؟",
        options: ["مرة واحدة", "مرتين", "3 مرات", "4 مرات"],
        hint: "العدد الذي تنبأ به يسوع",
        funFact: "🐓 صياح الديك ذكّر بطرس بنبوءة يسوع!"
      },
      medium: {
        question: "أين كان بطرس عندما أنكر يسوع؟",
        options: [
          "في الهيكل",
          "عند بيلاطس",
          "في دار رئيس الكهنة",
          "على الطريق"
        ],
        hint: "كان يتبع يسوع من بعيد",
        funFact: "🔥 كان بطرس يستدفئ بالنار مع أعداء يسوع!"
      },
      hard: {
        question: "ماذا يعلمنا استعادة بطرس بعد إنكاره؟",
        options: [
          "بعض الخطايا لا تُغفر",
          "محبة يسوع ترفع حتى أعظم سقطاتنا",
          "كان بطرس غير جدير",
          "يجب إخفاء أخطائنا"
        ],
        hint: "يتعلق الأمر بالنعمة التي تستعيد",
        funFact: "💝 سأل يسوع 3 مرات 'أتحبني؟' ليستعيد الإنكارات الثلاثة!"
      }
    },

    42: {
      name: "يسوع أمام بيلاطس",
      challenge: "أَأَنْتَ مَلِكُ الْيَهُودِ؟ أَنْتَ تَقُولُ...",
      easy: {
        question: "من كان الحاكم الروماني الذي حاكم يسوع؟",
        options: ["قيصر", "بيلاطس", "هيرودس", "أنطونيوس"],
        hint: "ممثل روما في اليهودية",
        funFact: "⚖️ يعترف بيلاطس ببراءة يسوع لكنه يحكم عليه بالجبن!"
      },
      medium: {
        question: "ما هو العرف الذي اقترح بيلاطس استخدامه؟",
        options: [
          "إطلاق سراح سجين في عيد الفصح",
          "تأجيل المحاكمة",
          "الاستئناف إلى قيصر",
          "نفي يسوع"
        ],
        hint: "تقليد الفصح",
        funFact: "🔓 كان بيلاطس يأمل في إطلاق سراح يسوع بفضل هذا العرف!"
      },
      hard: {
        question: "ماذا يكشف موقف بيلاطس عن العدالة البشرية؟",
        options: [
          "العدالة تُقام دائمًا",
          "الضغط الشعبي يمكن أن يفسد حتى العدالة",
          "كان بيلاطس شريرًا",
          "السياسة تسبق الحقيقة"
        ],
        hint: "يتعلق الأمر بالضعف أمام الحشد",
        funFact: "💧 يغسل بيلاطس يديه لكنه يبقى مسؤولاً عن الظلم!"
      }
    }
  }
};

export default chapter4Translations;
